import { createFileRoute } from '@tanstack/react-router';

import { PlansPage } from '../modules/plans/ui/pages/PlansPage';

export const Route = createFileRoute('/_authenticated/super-admin/plans/')({
  component: PlansPage,
  staticData: {
    breadcrumb: ['Platform', 'Plans'],
  },
});
